module.exports = __webpack_public_path__ + "img/李忠@2x.747e5c80.png";